var map = {
	"./affix/style/index.tsx": 990,
	"./alert/style/index.tsx": 992,
	"./anchor/style/index.tsx": 994,
	"./auto-complete/style/index.tsx": 996,
	"./avatar/style/index.tsx": 1001,
	"./back-top/style/index.tsx": 1003,
	"./badge/style/index.tsx": 1005,
	"./breadcrumb/style/index.tsx": 1007,
	"./button/style/index.tsx": 192,
	"./calendar/style/index.tsx": 1009,
	"./card/style/index.tsx": 1012,
	"./carousel/style/index.tsx": 1015,
	"./cascader/style/index.tsx": 1017,
	"./checkbox/style/index.tsx": 195,
	"./col/style/index.tsx": 1020,
	"./collapse/style/index.tsx": 1021,
	"./date-picker/style/index.tsx": 1023,
	"./divider/style/index.tsx": 1026,
	"./dropdown/style/index.tsx": 915,
	"./form/style/index.tsx": 1029,
	"./grid/style/index.tsx": 365,
	"./icon/style/index.tsx": 1031,
	"./input-number/style/index.tsx": 1032,
	"./input/style/index.tsx": 114,
	"./layout/style/index.tsx": 1034,
	"./list/style/index.tsx": 1036,
	"./locale-provider/style/index.tsx": 1040,
	"./mention/style/index.tsx": 1042,
	"./menu/style/index.tsx": 1044,
	"./message/style/index.tsx": 1047,
	"./modal/style/index.tsx": 1049,
	"./notification/style/index.tsx": 1051,
	"./pagination/style/index.tsx": 367,
	"./popconfirm/style/index.tsx": 1053,
	"./popover/style/index.tsx": 916,
	"./progress/style/index.tsx": 917,
	"./radio/style/index.tsx": 363,
	"./rate/style/index.tsx": 1056,
	"./row/style/index.tsx": 1058,
	"./select/style/index.tsx": 194,
	"./slider/style/index.tsx": 1059,
	"./spin/style/index.tsx": 366,
	"./steps/style/index.tsx": 1061,
	"./switch/style/index.tsx": 1063,
	"./table/style/index.tsx": 1065,
	"./tabs/style/index.tsx": 913,
	"./tag/style/index.tsx": 1067,
	"./time-picker/style/index.tsx": 914,
	"./timeline/style/index.tsx": 1069,
	"./tooltip/style/index.tsx": 361,
	"./transfer/style/index.tsx": 1071,
	"./tree-select/style/index.tsx": 1073,
	"./tree/style/index.tsx": 1075,
	"./upload/style/index.tsx": 1077,
	"./version/style/index.tsx": 1079
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 989;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/[^_][\w-]+\/style\/index\.tsx?$
// module id = 989
// module chunks = 1